module.exports = __webpack_public_path__ + "static/media/social_media_fb.7ee89e9e.svg";